import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'cva-dashboard',
    templateUrl: './dashboard.component.html',
    
})
export class DashboardComponent {

}
